<template>
  <div>
    <title-component :title="title"></title-component>
    <div class="row width_full">
      <div class="col_12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">{{ $t('basic_information') }}</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('subject_id')}]">
                  <label>{{ $t('common.subject') }}</label>
                  <select v-model="form.subject_id" class="form_global">
                    <option value="">{{ $t('common.select_subject') }}</option>
                    <option :value="subject.id" v-for="subject in subjects" :key="'subject_'+subject.id">{{ subject.name }}</option>
                  </select>
                  <v-errors :errors="errorFor('subject_id')" />
                </div>
              </div>

              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('area_id')}]">
                  <label>{{ $t('common.area') }}</label>
                  <select v-model="form.area_id" class="form_global">
                    <option value="">{{ $t('common.select_area') }}</option>
                    <option :value="area.id" v-for="area in areas" :key="'area_'+area.id">{{ area.name }}</option>
                  </select>
                  <v-errors :errors="errorFor('area_id')" />
                </div>
              </div>

              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('grade')}]">
                  <label>{{ $t('common.grade') }}</label>
                  <select class="form_global" id="grade" v-model="form.grade">
                    <option value="">{{ $t('common.select') }}</option>
                    <option value="all">{{ $t('common.all') }}</option>
                    <option value="grade-one">{{ $t('grade_one') }}</option>
                    <option value="grade-two">{{ $t('grade_two') }}</option>
                    <option value="grade-three">{{ $t('grade_three') }}</option>
                    <option value="grade-four">{{ $t('grade_four') }}</option>
                    <option value="grade-five">{{ $t('grade_five') }}</option>
                    <option value="grade-six">{{ $t('grade_six') }}</option>
                  </select>
                  <v-errors :errors="errorFor('grade')"></v-errors>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('semester_id')}]">
                  <label>{{ $t('common.semester') }}</label>
                  <select v-model="form.semester_id" class="form_global">
                    <option value="">{{ $t('common.select_semester') }}</option>
                    <option :value="semester.id" v-for="semester in semesters" :key="'semester '+semester.id">{{ semester.name }}</option>
                  </select>
                  <v-errors :errors="errorFor('semester_id')" />
                </div>
              </div>
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('unit_id')}]">
                  <label>{{ $t('common.unit') }}</label>
                  <select v-model="form.unit_id" class="form_global">
                    <option value="">{{ $t('common.select_unit') }}</option>
                    <option :value="unit.id" v-for="unit in units" :key="'unit '+unit.id">{{ unit.unit_name }}</option>
                  </select>
                  <v-errors :errors="errorFor('unit_id')" />
                </div>
              </div>

              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('fellowship_name')}]">
                  <label>{{ $t('fellowship_name') }}</label>
                  <input type="text" class="form_global" v-model="form.fellowship_name">
                  <v-errors :errors="errorFor('fellowship_name')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('volume_id')}]">
                  <label>{{ $t('volume') }}</label>
                  <select class="form_global" id="volume_id" v-model="form.volume_id">
                    <option value="">{{ $t('common.select') }}</option>
                  </select>
                  <v-errors :errors="errorFor('volume_id')"></v-errors>
                </div>
              </div>
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('page')}]">
                  <label>{{ $t('page') }}</label>
                  <input type="number" class="form_global" v-model="form.page" min="0">
                  <v-errors :errors="errorFor('page')" />
                </div>
              </div>
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('status')}]">
                  <label>{{ $t('common.status') }}</label>
                  <div class="form_inline">
                    <div class="form_radio">
                      <input type="radio" id="waiting" value="waiting" v-model="form.status">
                      <label for="waiting">{{ $t('common.active') }}</label>
                    </div>
                    <div class="form_radio">
                      <input type="radio" id="posting" value="posting" v-model="form.status">
                      <label for="posting">{{ $t('common.inactive') }}</label>
                    </div>
                  </div>
                  <v-errors :errors="errorFor('status')" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-title">{{ $t('video_information') }}</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col_12">
                <div :class="['form-group', {'has_error': errorFor('video_name')}]">
                  <label>{{ $t('common.name') }}</label>
                  <input type="text" class="form_global" v-model="form.video_name">
                  <v-errors :errors="errorFor('video_name')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_12">
                <div :class="['form-group', {'has_error': errorFor('learning_goal')}]">
                  <label>{{ $t('sidebar.lectureCommon.learning_goal') }}</label>
                  <input type="text" class="form_global" v-model="form.learning_goal">
                  <v-errors :errors="errorFor('learning_goal')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_12">
                <div :class="['form-group', {'has_error': errorFor('lecture_information')}]">
                  <label>{{ $t('sidebar.lectureCommon.lecture_information') }}</label>
                  <textarea rows="7" cols="50" class="form_global" v-model="form.lecture_information"></textarea>
                  <v-errors :errors="errorFor('lecture_information')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_12">
                <div :class="['form-group', {'has_error': errorFor('video_upload')}]">
                  <label>{{ $t('sidebar.lectureCommon.video_upload') }}</label>
                  <div class="progress_wrap" v-if="showProgressbar">
                    <div class="meter">
                        <span :style="{ 'width': + uploadProgress + '%' } "><span class="progress"></span></span>
                        <div class="percent">{{ uploadProgress }}%</div>
                    </div>
                  </div>
                  <vue-dropzone class="create_images_drag" id="upload_dropzone" ref="upload_dropzone" :options="dropzoneOptions"
                      @vdropzone-total-upload-progress="dropzoneUploadProgress"
                      @vdropzone-file-added="dropzoneFileAdded"
                      @vdropzone-success="dropzoneSuccess"
                      @vdropzone-complete="dropzoneComplete"
                      :useCustomSlot="true">
                  </vue-dropzone>
                  <p class="showErrorMessage" style="color:red" v-if="showUploadError">{{ showUploadErrorMsg }}</p>
                  <v-errors :errors="errorFor('video_upload')" />
                </div>
              </div>
            </div>

            <div class="d_flex_end">
              <router-link class="btn btn_success mr_5" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
              <button class="btn  btn_success" :disabled="loading" @click.prevent="submit()">{{ $t('common.submit') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleComponent from "@/components/TitleComponent";
import vueDropzone from 'vue2-dropzone-vue3'
export default {
  components: {
    TitleComponent,
    vueDropzone,
  },
  data() {
    return {
      title: this.$t('createLearningVideo'),
      cancelRouteName: 'unit_learning_video_list',
      subjects: [],
      areas: [],
      semesters: [],
      units: [],
      form: {
        subject_id: '',
        area_id: '',
        grade: '',
        semester_id: '',
        unit_id: '',
        fellowship_name: '',
        volume_id: '',
        page: '',
        status: 'posting',
        video_name: '',
        learning_goal: '',
        lecture_information: '',
        files: '',
        originalFiles: '',
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
        addRemoveLinks: false,
        uploadMultiple: false,
        disablePreviews: false,
        createImageThumbnails: true,
        allowMultiple: false,
        maxFiles: 1,
        previewTemplate: '<div></div>',
        init: function() {
            this.on("error", function(file){
                this.showUploadError = true
                this.showUploadErrorMsg = '파일 업로드 실패: ' + file.xhr.statusText;
            });
        },
        maxFilesize: 5120,
        thumbnailHeight: 120,
        timeout: 9999990000,
        acceptedFiles: "video/mp4,video/x-m4v,video/*",
        headers: {
          "Authorization": `Bearer `+ JSON.parse(localStorage.getItem('admin')).token
        }
      },
      showUploadError : false,
      showUploadErrorMsg : '',
      showProgressbar: false,
      tempFile: null,
      uploadProgress: 0,
      loading: true
    }
  },
  created() {
    this.axios.get('/subjects').then((response) => this.subjects = response.data.data);

    this.axios.get('/areas').then((response) => this.areas = response.data.data);

    this.axios.get('/semesters').then((response) => this.semesters = response.data.data);

    this.axios.get('/units').then((response) => this.units = response.data.data);

    if (this.$route.name === 'unit_learning_video_edit') {
      this.axios.get('/learning-videos/'+this.$route.params.id)
        .then((response) => {
          let editVideoData = response.data.data;

          this.form.subject_id = editVideoData.subject ? editVideoData.subject.id : '';
          this.form.area_id = editVideoData.area ? editVideoData.area.id : '';
          this.form.grade = editVideoData.grade
          this.form.semester_id = editVideoData.semester ? editVideoData.semester.id : '';
        })
      this.title = this.$t('editLearningVideo');
    }
  },
  methods: {
    dropzoneFileAdded(){
      this.showUploadError = false
      this.showUploadErrorMsg = '';
    },
    dropzoneUploadProgress(totaluploadprogress){
        this.showProgressbar = true;
        this.uploadProgress = parseInt(totaluploadprogress)
    },
    dropzoneSuccess(file, response){
      this.form.files = response.original_filename;
      this.form.originalFiles = file.name;
    },
    dropzoneComplete(response){
        if(response.status == 'success' && this.uploadProgress == 100){
          this.loading = false
        }
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'unit_learning_video_edit') {
        this.axios.patch('/learning-videos/'+this.$route.params.id, this.form)
          .then(() => {
            this.$router.push({name: 'unit_learning_video_list'});
            this.showSuccessMsg(this.$t('common.updateSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        let formData = new FormData()

        Object.keys(this.form).forEach(key => {
            formData.append(key, this.form[key] ? this.form[key] : '');
        })

        this.axios.post('/learning-videos', formData)
          .then(() => {
            // this.$router.push({name: 'unit_learning_video_list'});
            // this.showSuccessMsg(this.$t('common.addSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
}
</script>
